import React from 'react';
import { observer } from 'mobx-react-lite';
import { useInfiniteAPI } from 'polotno/utils/use-api';

import { SectionTab } from 'polotno/side-panel';
import MdPhotoLibrary from '@meronex/icons/md/MdPhotoLibrary';
import MdFolder from '@meronex/icons/md/MdFolder';

import { ImagesGrid } from 'polotno/side-panel/images-grid';

export const TemplatesPanel = observer(({ store }) => {
  // load data
  const { data, isLoading } = useInfiniteAPI({
    getAPI: ({ page }) => `templates-ubsi/page${page}.json`,
  });

  return (
    <div class='custom-templates-ubsi' style={{ height: '100%' }}>
      <ImagesGrid
        shadowEnabled={true}
        images={data?.map((data) => data.items).flat()}
        getPreview={(item) => `templates-ubsi/${item.preview}`}
        isLoading={isLoading}
        onSelect={async (item) => {
          // download selected json
          const req = await fetch(`templates-ubsi/${item.json}`);
          const json = await req.json();
          // just inject it into store
          store.loadJSON(json);
        }}
        rowsNumber={2}
      />
    </div>
  );
});

// define the new custom section
export const TemplatesSectionUBSI = {
  name: 'custom-templates-ubsi',
  Tab: (props) => (
    <SectionTab name="UBSI" {...props}>
          <div
            style={{
              maxWidth: '200px',
            }}
          >
            <img
              src="ubsi.svg"
	  		  alt="UBSI"
	  		  style={{
              height: '39px',
              maxWidth: '200px',
              }}
            />
          </div>
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: TemplatesPanel,
};
